import { ISupportCountry } from './countryGroup';
import { IPlan, IProductPlan } from './plan';

/**
 * 套餐系列类型
 */
export enum ESeriesCategory {
    /** @deprecated 云存储套餐 */
    STORAGE_PLAN = 'storage_plan',
    /** @deprecated 流量套餐 */
    TRAFFIC_PLAN = 'traffic_plan',
    /** 云存储套餐 */
    CLOUD_STORAGE_PLAN = 'cloud_storage_plan',
    /** 云存储+数据套餐 */
    CLOUD_STORAGE_DATA_PLAN = 'cloud_storage_data_plan',
    /** 流量套餐 */
    CLOUD_DATA_PLAN = 'cloud_data_plan',
    /** 流量补充包套餐 */
    CLOUD_DATA_ADD_ON_PLAN = 'cloud_data_add_on_plan',
    /**
     * 带图推送套餐
     */
    CLOUD_RICH_NOTIFICATION_PLAN='cloud_rich_notification_plan'
}
export interface IPlanSeries {

    /**
     * key
     *
     * 长度:1-64 个字符
     */
    key: string;

    /**
     * 前台显示参数
     */
    style: {
        'series.display_color': string;
        'series.recommended': number;
        'series.sort': number;
        [x: string]: any;
    };

    /**
     * 套餐系列类型
     */
    category: ESeriesCategory;

    /**
     * 套餐适用机型组 key
     *
     * 长度:1-64 个字符
     */
    deviceGroup: string;

    /**
     * 国家组 key 列表
     *
     * 取值范围: 国家组 key 1-64 个字符
     */
    countryGroups: string[];

    /**
     * 存储地 key
     *
     * 长度:1-64 个字符
     */
    storageRegion: string;

    /**
     * i18n 语言包参数
     */
    i18n: Record<string, string> & {
        name: string;
    };

    legacyTag: string;

}

export type IProductSeries = IPlanSeries & {
    plans: IProductPlan[];
    /**
     *
     */
    supportedCountryList: ISupportCountry[];
};

export interface ISeriesItem {
    seriesName: string;
    products: IPlan[];
    sortOrder: number;
    deviceGroup: string;
}